<div class="episode-ribbon-container">
    <div class="ribbon-header">
        <ng-container *ngIf="!hideFormsTitle">
            <span class="formdot"></span>
            <span>Form</span>
        </ng-container>
        <div class="ribbon-header-options-button">
            <button doNotPropagateClick
                    type="button"
                    pButton
                    pRipple
                    icon="mi mi-button-more"
                    class="p-button-secondary p-button-rounded p-button-text"
                    (click)="asyncMenu.toggle($event)"></button>
            <async-menu
                #asyncMenu
                [menuItems]="menuOptions"></async-menu>
        </div>
    </div>

    <div class="form-info">
        <span class="form-name" [ngClass]="{ 'is-archived': isArchived }">
            <b>{{ formName || form?.formDefinition?.name }}</b>
        </span>

        <div class="form-actions" *ngIf="pdfExportMode !== FormPdfExportMode.None">
            <!-- Show/Hide Form button for Auto PDF (loads from server initially) -->
            <button pButton
                    allowOffline
                    *ngIf="pdfExportMode === FormPdfExportMode.Auto"
                    class="hidden sm:inline-flex p-button-secondary p-button-text ml-4"
                    [icon]="isLoadingForm() ? 'pi pi-spin pi-spinner' : (isFormLoaded() ? 'pi pi-eye-slash' : 'pi pi-eye')"
                    [label]="isFormLoaded() ? 'Hide' : 'Show'"
                    [disabled]="isLoadingForm()"
                    (click)="isFormLoaded() ? isFormLoaded.set(false) : loadForm()"></button>

            <!-- Show/Hide Form button for Custom PDF -->
            <button pButton
                    allowOffline
                    *ngIf="pdfExportMode === FormPdfExportMode.CustomPDF"
                    class="hidden sm:inline-flex p-button-secondary p-button-text ml-4"
                    [icon]="isCustomFormLoaded() ? 'pi pi-eye-slash' : 'pi pi-eye'"
                    [label]="isCustomFormLoaded() ? 'Hide' : 'Show'"
                    (click)="toggleCustomFormVisibility()"></button>

            <!-- Full/Preview toggle (only visible when form is loaded) -->
            <button pButton
                    allowOffline
                    *ngIf="pdfExportMode === FormPdfExportMode.Auto && isFormLoaded()"
                    class="hidden sm:inline-flex p-button-secondary p-button-text"
                    [icon]="isFullView ? 'mi mi-collapse-all' : 'mi mi-expand-all'"
                    (click)="toggleFullView()"></button>

            <!-- View button for Auto mode -->
            <p-button *ngIf="pdfExportMode === FormPdfExportMode.Auto"
                      [icon]="isLoadingForm() ? 'pi pi-spin pi-spinner' : 'pi pi-cloud-download'"
                      [disabled]="isLoadingForm()"
                      iconPos="right"
                      label="View"
                      styleClass="hidden md:inline-flex p-button-secondary p-button-text"
                      (onClick)="viewForm()"></p-button>

            <button *ngIf="pdfExportMode === FormPdfExportMode.Auto"
                    pButton
                    pRipple
                    type="button"
                    [icon]="isLoadingForm() ? 'pi pi-spin pi-spinner' : 'pi pi-cloud-download'"
                    [disabled]="isLoadingForm()"
                    class="md:hidden p-button-secondary p-button-rounded p-button-text"
                    (click)="viewForm()"></button>

            <!-- Expand/Collapse button for CustomPDF mode (only visible when form is loaded) -->
            <button pButton
                    allowOffline
                    *ngIf="pdfExportMode === FormPdfExportMode.CustomPDF && isCustomFormLoaded()"
                    class="hidden sm:inline-flex p-button-secondary p-button-text"
                    [icon]="isFullCustomPdfView ? 'mi mi-collapse-all' : 'mi mi-expand-all'"
                    (click)="toggleCustomPdfFullView()"></button>

            <p-button *ngIf="pdfExportMode === FormPdfExportMode.CustomPDF"
                      icon="pi pi-file-pdf"
                      iconPos="right"
                      label="Export"
                      styleClass="hidden md:inline-flex p-button-secondary p-button-text"
                      (onClick)="onPreviewCustomPdf()"></p-button>

            <p-button *ngIf="pdfExportMode === FormPdfExportMode.Auto"
                      icon="pi pi-share-alt"
                      iconPos="right"
                      label="Share"
                      styleClass="hidden md:inline-flex p-button-secondary p-button-text"
                      (onClick)="share()"></p-button>

            <button pButton
                    pRipple
                    type="button"
                    icon="pi pi-share-alt"
                    class="md:hidden p-button-secondary p-button-rounded p-button-text"
                    (click)="share()"></button>

            <p-button [disabled]="!canDelete"
                      icon="mi mi-button-remove text-danger"
                      iconPos="right"
                      label="Delete"
                      styleClass="hidden md:inline-flex p-button-secondary p-button-text"
                      (onClick)="archive()"></p-button>
            <button [disabled]="!canDelete"
                    pButton
                    pRipple
                    type="button"
                    icon="mi mi-button-remove text-danger"
                    class="md:hidden p-button-secondary p-button-rounded p-button-text"
                    (click)="archive()"></button>
        </div>

        <!-- Auto PDF Viewer - Only show when loaded -->
        <div *ngIf="pdfExportMode === FormPdfExportMode.Auto && isFormLoaded() && urlPdf" class="pdf-viewer">
            <iframe [src]="safePdfUrl"
                    [style.height]="iframeHeight"
                    [style.width]="iframeWidth"
                    [ngClass]="{ 'preview': !isFullView, 'full': isFullView }"></iframe>
        </div>

        <!-- Custom PDF Viewer - Only show when loaded -->
        <div *ngIf="pdfExportMode === FormPdfExportMode.CustomPDF && isCustomFormLoaded()" class="custom-pdf-viewer">
            <div [ngClass]="{ 'custom-pdf-viewer-preview': !isFullCustomPdfView, '': isFullCustomPdfView }">
                <reporting-dashboard [dashboardId]="customPdfDashboardId"
                                     [staticVariables]="customPdfVariables"
                                     [variableReceiver]="true"
                                     output="PDF"></reporting-dashboard>
            </div>
        </div>
    </div>

    <div class="ribbon-footer">
        <span class="sm:mr-3">{{ creationDate }}</span>
        <span class="sm:mr-1">
            Created by:
            <span *ngIf="!isMuf"> <b>{{ createdByUserName }}</b></span>
            <span (mouseover)="showOverlayPanel($event)"
                  (mouseout)="hideOverlayPanel()"
                  *ngIf="isMuf"> <b> Multiple</b></span>
        </span>

        <span class="mr-1">
            Category: <b>{{ categoryForm }}</b>
        </span>

        <span class="sm:mr-1">
            Owned by: <b>{{ createdByOrganisationName }}</b>
        </span>
    </div>
</div>

<m-historical-dialog
    [visible]="episodeDocumentShowHistorical()"
    (visibleChange)="episodeDocumentShowHistorical.set($event)"
    [items]="episodeDocumentHistoricalItems()"></m-historical-dialog>
<m-fileShare [fileDetailsId]="sharingFileId" [(visible)]="sharingFile"></m-fileShare>

<p-overlayPanel #userOverlayInfo appendTo="body">
    <div *ngFor="let info of usersInfo">
        <m-user-initials [title]="info.title"
                         [fullName]="info.fullName"
                         [role]="info.roles"
                         circleStyleClass="created-by">
        </m-user-initials>
    </div>
</p-overlayPanel>